import { queryBuilder } from '~/api';

export const deleteCalendarRecurrence = async (
  recurrenceId: number
): Promise<void> => {
  await queryBuilder('DELETE', `calendar/recurrence/${recurrenceId}`);
  return;
};
